export { default } from './request-service-part-details';
